import { Link, NavLink, useLocation } from "react-router-dom";
import Brand from "@/components/brand";
import AuthStatus from "@/components/auth-status";
import { List, Plus, Trophy } from "lucide-react";

export default function SiteHeader() {
  const location = useLocation();
  const navItems = [
    { to: "/", label: "一覧", icon: List },
    { to: "/add", label: "追加", icon: Plus },
    { to: "/rankings", label: "ランキング", icon: Trophy },
  ];

  return (
    <>
      <header className="sticky top-0 z-40 w-full border-b bg-background/90 backdrop-blur supports-[backdrop-filter]:bg-background/70">
        <div className="container mx-auto flex h-12 max-w-6xl items-center gap-3 px-3 sm:h-14 sm:px-4">
          <Link to="/" className="inline-flex items-center gap-2 shrink-0" aria-label="トップへ">
            <Brand size="md" />
          </Link>
          <nav className="hidden items-center gap-1 sm:flex">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    "inline-flex h-9 items-center gap-1 rounded-md px-3 text-sm transition " +
                    (isActive ? "bg-secondary text-foreground" : "text-muted-foreground hover:bg-secondary/70 hover:text-foreground")
                  }
                >
                  <Icon className="h-4 w-4" />{item.label}
                </NavLink>
              );
            })}
          </nav>
          <div className="ml-auto">
            <AuthStatus />
          </div>
        </div>
      </header>
      <nav className="fixed inset-x-0 bottom-0 z-40 border-t bg-background/95 px-2 py-2 backdrop-blur sm:hidden">
        <div className="mx-auto grid max-w-sm grid-cols-3 gap-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = item.to === "/" ? location.pathname === "/" : location.pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={
                  "flex h-11 flex-col items-center justify-center rounded-md text-[11px] " +
                  (active ? "bg-secondary text-foreground" : "text-muted-foreground")
                }
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}
